import React from "react";
export const Flag = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.11068 1.6875C2.11068 1.32383 1.81345 1.03125 1.44401 1.03125C1.07457 1.03125 0.777344 1.32383 0.777344 1.6875V2.78125V10.6152V11.9688V14.375C0.777344 14.7387 1.07457 15.0312 1.44401 15.0312C1.81345 15.0312 2.11068 14.7387 2.11068 14.375V11.6406L4.34123 11.091C5.4829 10.8094 6.69123 10.9406 7.74401 11.4574C8.97179 12.0617 10.3968 12.1355 11.6801 11.6598L12.644 11.3043C12.9912 11.1758 13.2218 10.8504 13.2218 10.484V2.83867C13.2218 2.20977 12.5496 1.79961 11.9773 2.08125L11.7107 2.2125C10.4246 2.84688 8.91068 2.84688 7.62457 2.2125C6.64957 1.73125 5.53012 1.61094 4.47179 1.8707L2.11068 2.45312V1.6875ZM2.11068 3.80664L4.79401 3.14492C5.54401 2.96172 6.33568 3.04648 7.02734 3.38555C8.55234 4.13477 10.3246 4.19766 11.8885 3.57148V10.1832L11.2107 10.432C10.2746 10.7766 9.2329 10.7246 8.33846 10.2844C6.99957 9.62539 5.46901 9.46133 4.01623 9.8168L2.11068 10.2871V3.80664Z"
        fill="#775FD5"
        stroke="#775FD5"
        stroke-width="0.5"
      />
    </svg>
  );
};
